<div class="row align-items-center" [ngClass]="entry | formListEntryCssClass" (click)="previewForm.emit($event)">
    <div class="col-auto fs-4"><fa-icon [icon]="entry | formListIcon"></fa-icon></div>
    <div class="col">
        <div class="row gy-1">
            <div class="col-12 fw-bold">{{ entry.title }}: {{ entry.variant }}</div>
            <div class="col-12">{{ entry.id.formId }}</div>
            <div class="col" *ngIf="entry.lockedBy.length > 0">
                <!-- locked? -->
                <fa-icon [icon]="faLock"></fa-icon>
                {{ entry.lockedBy }}
            </div>
            <div class="col" *ngIf="entry.lockedBy.length === 0">
                <!-- locked? -->
                <fa-icon [icon]="faUnlock"></fa-icon>
                {{ 'SELECT_FORM_UNLOCKED' | translate }}
            </div>
            <div class="col-auto ms-auto">
                <span class="ms-1">
                    <!-- status icon: template or interim? -->
                    <fa-icon *ngIf="hasBeenLoadedFromTemplate(entry)" [icon]="faCircle"></fa-icon>
                    <fa-icon *ngIf="hasBeenLoadedFromInterim(entry)" [icon]="faDotCircle"></fa-icon>
                </span>
                <span class="ms-1">
                    <!-- downloaded or uploaded? -->
                    <fa-icon *ngIf="hasBeenUploaded(entry)" [icon]="faCloudUpload"></fa-icon>
                    <fa-icon *ngIf="!hasBeenUploaded(entry) && !entry.cached" [icon]="faCloud"></fa-icon>
                    <fa-icon *ngIf="!hasBeenUploaded(entry) && entry.cached" [icon]="faCloudDownload"></fa-icon>
                </span>
            </div>
            <div class="col-12" *ngIf="entry.previousSubmit || entry.submitStatus !== 'U'">
                <span class="col-form-label text-start">{{ 'SELECT_FORM_STATUS_TITLE' | translate }}: </span>
                <span>
                    {{ entry | formsListSubmitStatus | translate }}
                </span>
            </div>
        </div>
    </div>
    <div class="col-auto d-flex flex-column-reverse gap-1">
        <!-- Abort form-->
        <button
            class="btn btn-small btn-secondary"
            *ngIf="showAbortFormButton"
            [disabled]="disableAbortButton(entry)"
            (click)="abortForm.emit($event)"
            [attr.aria-label]="('F4M_LIST_ABORT_FORM_ARIA_LABEL' | translate) + entry.id.formId"
        >
            <fa-icon [icon]="faMinusCircle"></fa-icon>
        </button>
        <!-- instructions documentation-->
        <button
            class="btn btn-small btn-secondary"
            *ngIf="showDocumentationLink"
            (click)="openInstructions.emit($event)"
            [attr.aria-label]="('F4M_LIST_OPEN_INSTRUCTIONS_ARIA_LABEL' | translate) + entry.id.formId"
        >
            <fa-icon [icon]="faFilePdf"></fa-icon>
        </button>
        <!-- Refresh XML -->
        <button
            class="btn btn-small btn-secondary"
            *ngIf="showRefreshXMLButton"
            (click)="refreshXML.emit($event)"
            [attr.aria-label]="('F4M_LIST_REFRESH_XML_ARIA_LABEL' | translate) + entry.id.formId"
        >
            <fa-icon [icon]="faSyncAlt"></fa-icon>
        </button>
        <!-- open in edit mode -->
        <button
            class="btn btn-small btn-secondary"
            [disabled]="hasBeenUploaded(entry)"
            (click)="editForm.emit($event)"
            [attr.aria-label]="('F4M_LIST_EDIT_FORM_ARIA_LABEL' | translate) + entry.id.formId"
        >
            <fa-icon [icon]="faPencil"></fa-icon>
        </button>
    </div>
</div>
<hr />
